export default {"src":"/_next/static/image/public/images/icons/error-toast.225d2d7410191d93894aeaab94e89765.svg","height":16,"width":16};